import { AxiosError } from 'axios';
import { api } from '@/Data/api';
import ss from '../Session';
import { SocialResponse } from './types';

/**
 * Mr. MATE Essay Topic type based on API documentation
 */
export type EssayTopic = {
    topicid: string;
    hashtags: string[];
    encouraging_kr: string;
    encouraging_id: string;
    created_date: string;
    created_at: number;
};

export type MrMateResponse = {
    topics: EssayTopic[];
};

/**
 * Get daily hashtag topics from Mr. MATE
 * Returns the latest 3 bilingual hashtag topics for Korean language learning essay writing
 * @returns Promise with essay topics array or null if failed
 */
export const getMrMateTopics = async (): Promise<EssayTopic[] | null> => {
    try {
        const res = await api.get<SocialResponse<MrMateResponse>>('/social/mrmate', {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            }
        });
        
        return res.data?.code === 200 ? (res.data.data?.topics ?? []) : null;
    } catch (e) {
        if (e instanceof AxiosError && e.response?.data?.code === 404) {
            console.warn('No Mr. MATE topics found');
            return [];
        }
        
        console.error('Failed to get Mr. MATE topics:', e);
        return null;
    }
};